import { forwardRef, memo } from 'react';

import { StyledContainer } from './styled.ts';
import { ContainerLayout, type ContainerProps, type ContainerPropsWithLayout, type ContainerPropsWithoutLayout } from './types.ts';

export { ContainerLayout, type ContainerProps, type ContainerPropsWithLayout, type ContainerPropsWithoutLayout };

export const Container = memo(
  forwardRef<HTMLDivElement, ContainerProps>(function Container({ fluid, layout, children, className, dataTestId, spacer }, ref) {
    return (
      <StyledContainer ref={ref} $fluid={fluid} $layout={layout} $spacer={spacer} className={className} data-testid={dataTestId}>
        {children}
      </StyledContainer>
    );
  }),
);
